/* Progressive UI only: no cart API requests or analytics events are emitted here. */
(() => {
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-pp-comparison]')) return;
    const comparison = event.target.closest('.pp-example')?.querySelector('pp-comparison');
    comparison?.style.setProperty('--pp-reveal', `${event.target.value}%`);
  });

  if (customElements.get('pp-sticky-purchase')) return;
  customElements.define('pp-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.main = document.querySelector('product-info[data-update-url="true"]');
      if (!this.main) return;
      this.button = this.querySelector('[data-pp-return]');
      this.originalPadding = document.body.style.paddingBottom;
      const { signal } = this.controller;
      this.button.addEventListener('click', () => {
        const target = this.main.querySelector('.product__info-container');
        const firstControl = target?.querySelector('variant-selects input:not([disabled]), variant-selects select:not([disabled]), .pp-photo-guide');
        const focusTarget = firstControl || this.main.querySelector('[name="add"]');
        if (!focusTarget) return;
        focusTarget.setAttribute('tabindex', focusTarget.getAttribute('tabindex') || '0');
        focusTarget.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        focusTarget.focus({ preventScroll: true });
      }, { signal });
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      document.addEventListener('focusin', this.schedule, { signal });
      document.addEventListener('focusout', this.schedule, { signal });
      document.addEventListener('toggle', this.schedule, { capture: true, signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { signal });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.main, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      const drawer = document.querySelector('cart-drawer');
      if (drawer) this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      this.update();
    }
    update() {
      const submit = this.main.querySelector('[name="add"]');
      if (!submit) { this.hidden = true; return; }
      const isDisabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      this.button.disabled = isDisabled;
      this.button.textContent = isDisabled ? this.dataset.unavailableLabel : this.dataset.availableLabel;
      const price = this.main.querySelector('[id^="price-"]');
      const priceTarget = this.querySelector('[data-pp-price]');
      if (price && price.innerHTML !== this.lastPrice) {
        this.lastPrice = price.innerHTML;
        priceTarget.innerHTML = price.innerHTML;
        priceTarget.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      }
      const active = document.activeElement;
      const editing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      const modal = document.querySelector('cart-drawer.active, details[open] .menu-drawer, product-modal[open], dialog[open], .shopify-pc__banner__dialog');
      const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
      this.hidden = window.innerWidth >= 750 || submit.getBoundingClientRect().bottom > 0 || !!modal || editing || !!keyboard;
      document.body.style.paddingBottom = this.hidden ? this.originalPadding : `${this.offsetHeight}px`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.body.style.paddingBottom = this.originalPadding || '';
    }
  });
})();
